import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Message, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ServiceShareCancelService.css';
const cx = classNames.bind(styles);

class ServiceShareCancelService extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, shareInfo, cancelShareService, handleOnToggleCancelModal } = this.props;
    const { serviceNo, serviceName, serviceUserName, serviceUserEmail, regEpoch } = shareInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleCancelModal}
        visible
        header={
          <div>
            {defineMessages(
              formatMessage({ id: 'ServiceShareCancelService_1', defaultMessage: '공유 받은 서비스 제거' })
            )}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleCancelModal}>
              {defineMessages(formatMessage({ id: 'ServiceShareCancelService_2', defaultMessage: '닫 기' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={onProgress} disabled={onProgress} onClick={cancelShareService}>
              {defineMessages(formatMessage({ id: 'ServiceShareCancelService_3', defaultMessage: '서비스 제거' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={onProgress}
          size="small"
          content={defineMessages(formatMessage({ id: 'ServiceShareCancelService_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {ReactHtmlParser(
            defineMessages(
              formatMessage({
                id: 'ServiceShareCancelService_5',
                defaultMessage:
                  '공유 받은 서비스를 제거합니다.<br/>해당 서비스 가입자가 다시 공유하기 전까지는<br/>접근할 수 없게 됩니다.<br/>정말로 공유 받은 다음 서비스를 제거합니까?'
              })
            )
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            {/* <div className={cx('template-detail-name')}>세부정보</div> */}
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelService_6', defaultMessage: '서비스No' }))}
                </div>
                {serviceNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelService_7', defaultMessage: '서비스명' }))}
                </div>
                {serviceName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelService_8', defaultMessage: '가입자' }))}
                </div>
                {serviceUserName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelService_9', defaultMessage: '이메일' }))}
                </div>
                {serviceUserEmail}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelService_10', defaultMessage: '공유시작' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

ServiceShareCancelService.propTypes = {
  //
};
ServiceShareCancelService.defaultProps = {
  //
};

export default injectIntl(ServiceShareCancelService);



// WEBPACK FOOTER //
// ./src/script/components/share/ServiceShareCancelService.js